module.exports = __webpack_public_path__ + "Lato-BlackItalic.5ac8681f3c56d3d451f2.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BlackItalic.woff
// module id = ../../../../../src/assets/fonts/Lato-BlackItalic.woff
// module chunks = styles